const SendMessage = {
  path: "",
  name: "",
  redirect: "/automation/sendmessage",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/automation/sendmessage",
      redirect: "/automation/sendmessage",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Send Message",
      meta: {
        requiresAuth: true,
        activeUrl: "/automation/sendmessage",
        parent: "automation",

        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () =>
            import("@/views/pages/automation/segmentation/SendMessage.vue"),
          meta: {
            requiresAuth: true,
            activeUrl: "/automation/sendmessage",
            parent: "automation",

            lv: 2,
          },
        },
        {
          path: "/sendmessage/detail/:id",
          name: "Send Message Detail",
          component: () =>
            import("@/views/pages/automation/segmentation/detail/Detail"),
          meta: {
            requiresAuth: true,
            isChildren: true,
            activeUrl: "/automation/sendmessage",
            parent: "automation",

            lv: 3,
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};
export default SendMessage;
